export let EScanQrCodeModalPages=function(EScanQrCodeModalPages){EScanQrCodeModalPages["ScanQrCodeStack"]="ScanQrCodeStack";return EScanQrCodeModalPages;}({});